/* StarringYou — suivi du tunnel.
   Chaque étape envoie le même événement à 3 endroits :
   1. Shopify (Customer events) : Shopify.analytics.publish('sy_step' | 'sy_lead' | 'sy_checkout')
      → le pixel personnalisé (06-SITE/tracking/custom-pixel.js) les relaie à Meta.
   2. Clarity : clarity('set','step') + clarity('event', ...) → filtres et entonnoir par étape.
   3. L'URL : ?step=N (history.pushState) → chaque étape est une « page » distincte dans Clarity. */
(function () {
  var sent = {};
  function pub(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function cl() {
    try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch (e) {}
  }
  window.SYTrack = {
    step: function (n, name, data) {
      var d = Object.assign({ step: n, step_name: name }, data || {});
      cl('set', 'funnel_step', n + '_' + name);
      cl('event', 'step_' + n + '_' + name);
      pub('sy_step', d);
      if (!sent[n]) { sent[n] = 1; pub('sy_step_first', d); }
    },
    event: function (name, data) {
      cl('event', name);
      pub(name, data || {});
    },
    tag: function (k, v) { cl('set', k, String(v)); }
  };
})();

/* Vidéos en boucle : autoplay forcé partout (bannière, cartes, télé).
   Safari/iOS bloque parfois l'autoplay (mode économie d'énergie, onglet en arrière-plan) : on relance
   à chaque occasion (chargement, retour sur l'onglet, entrée à l'écran) et au premier toucher / scroll. */
(function () {
  function prep(v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true; v.controls = false;
    ['muted', 'playsinline', 'webkit-playsinline', 'autoplay', 'loop', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
    v.removeAttribute('controls');
  }
  function play(v) { if (!v.paused) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function init() {
    var vids = [].slice.call(document.querySelectorAll('.sy video[autoplay]'));
    if (!vids.length) return;
    var visible = new Set();
    vids.forEach(function (v) {
      prep(v);
      ['loadedmetadata', 'canplay', 'pause'].forEach(function (ev) {
        v.addEventListener(ev, function () { if (visible.has(v) && !document.hidden) setTimeout(function () { play(v); }, ev === 'pause' ? 300 : 0); });
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { visible.add(e.target); play(e.target); } else { visible.delete(e.target); e.target.pause(); } });
      }, { rootMargin: '200px' });
      vids.forEach(function (v) { io.observe(v); });
    } else vids.forEach(function (v) { visible.add(v); play(v); });
    var kick = function () { visible.forEach(play); };
    ['touchstart', 'click', 'scroll', 'keydown'].forEach(function (ev) { window.addEventListener(ev, kick, { passive: true }); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    setInterval(function () { if (!document.hidden) kick(); }, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
